<template>
  <div class="animated fadeIn">
    <customer-contact-card
      v-if="customer_contact"
      :customer_contact="customer_contact"
      :is_form="true"
    />
    <b-form @submit.prevent="onSubmit">
      <b-card no-body>
        <b-card-header>
          <span class="text-muted text-uppercase">{{
            form_label
              ? form_label
              : customer_contact
                ? `Update ${customer_contact.first_name}`
                : "New Contact"
          }}</span>
        </b-card-header>
        <div class="py-3 px-5">
          <b-form-group label="First Name" :label-cols="3">
            <b-form-input
              v-model="form_data.first_name"
              :state="!$v.form_data.first_name.$invalid"
              invalid-feedback="Required"
              placeholder="First Name"
              type="text"
            />
          </b-form-group>
          <b-form-group label="Last Name" :label-cols="3">
            <b-form-input
              v-model="form_data.last_name"
              :state="!$v.form_data.last_name.$invalid"
              invalid-feedback="Required"
              placeholder="Last Name"
              type="text"
            />
          </b-form-group>
          <b-form-group label="Email" :label-cols="3">
            <b-form-input
              v-model="form_data.email"
              :state="!$v.form_data.email.$invalid"
              invalid-feedback="Required"
              placeholder="Email"
              type="email"
            />
          </b-form-group>
          <b-form-group label="Phone" :label-cols="3">
            <b-form-input
              v-model="form_data.phone"
              :state="!$v.form_data.phone.$invalid"
              invalid-feedback=""
              placeholder="Phone"
              type="text"
            />
          </b-form-group>
          <b-form-group label="Cell" :label-cols="3">
            <b-form-input
              v-model="form_data.cell"
              :state="!$v.form_data.cell.$invalid"
              invalid-feedback="Required"
              placeholder="Cell"
              type="text"
            />
          </b-form-group>
          <b-form-group label="Fax" :label-cols="3">
            <b-form-input
              v-model="form_data.fax"
              :state="!$v.form_data.fax.$invalid"
              invalid-feedback="Required"
              placeholder="Fax"
              type="text"
            />
          </b-form-group>
          <b-form-group
            :state="!$v.form_data.role.$invalid"
            :label-cols="3"
            invalid-feedback="Required"
            label="Role (i.e. Grower or Agronomist)"
          >
            <b-form-select
              v-model="form_data.role"
              :options="role_options"
            />
          </b-form-group>
          <b-form-group
            label="Login Access?"
            :label-cols="3"
          >
            <b-form-checkbox
              v-model="form_data.login_access"
              :value="1"
              :unchecked-value="0"
            />
          </b-form-group>
        </div>
      </b-card>
      <b-row v-if="!is_customer_form" class="mb-3" align-h="end">
        <b-col lg="2" md="4" sm="12">
          <b-button
            :disabled="isInvalid"
            @click="submitForm"  
            block          
            variant="success"
            ><i class="fal fa-address-book" /> Save</b-button
          >
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import CustomerContactCard from "@/components/crm/customercontact/CustomerContactCard.vue"
import { validationMixin } from "vuelidate/src";
import { required, email, helpers } from "vuelidate/lib/validators";

const phone = helpers.regex(
  "phone",
  /(\+\d{1,3}\s?)?((\(\d{3}\)\s?)|(\d{3})(\s|-?))(\d{3}(\s|-?))(\d{4})(\s(ext)(\s?\d+))*$/
);

const fax = helpers.regex(
  "fax",
  /(\+\d{1,3}\s?)?((\(\d{3}\)\s?)|(\d{3})(\s|-?))(\d{3}(\s|-?))(\d{4})(\s(ext)(\s?\d+))*$/
);

export default {
  name: "CustomerContactForm",
  components: { CustomerContactCard },
  mixins: [validationMixin],
  props: {
    customer_contact: {
      type: Object,
      default: () => null
    },
    form_label: {
      type: String,
      default: null
    },
    is_customer_form: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form_data: {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        cell: null,
        fax: null,
        role: null,
        login_access: 0
      },
      role_options: [
        { text: "No Type Selected", value: null },
        'Grower',
        'Agronomist'
      ]
    };
  },
  computed: {
    isInvalid() {
      return this.$v.$invalid;
    }
  },
  validations: {
    form_data: {
      first_name: { required },
      last_name: {  },
      email: { email },
      phone: { phone },
      cell: { phone },
      fax: { fax },
      role: { required },
      login_access: {}
    }
  },
  methods: {
    submitForm() {
      this.$emit("submit", this.form_data)
    }
  },
  watch: {
    form_data: {
      handler() {
        this.is_customer_form && this.$emit(
          "updateFormData",
          "customer_contact",
          this.form_data,
          !this.isInvalid
        )
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.customer_contact && (
      this.form_data = {
        ...this.customer_contact.cloneAttributes(
          true,
          true,
          ["id", "customer_id"]
        ),
        cell: this.customer_contact.cell
      }
    );
  }
};
</script>
